import { css, tokens, TooltipConfig } from '@sail/ui';
import { dynamic } from '@sail/engine';
export const tooltipCustomization = TooltipConfig.customize({
    defaults: {
        placement: 'top'
    },
    css: {
        paddingX: 'medium',
        paddingY: 'small',
        boxShadow: 'medium',
        border: 'none',
        font: 'body.medium',
        ':after': {
            content: '" "',
            width: 'space.0',
            height: 'space.0',
            position: 'absolute'
        }
    },
    uses: [
        dynamic((props)=>{
            const { placement } = props;
            const tooltipArrowStyles = [];
            if (placement === 'top') {
                tooltipArrowStyles.push(css({
                    translate: '0 -14px'
                }));
                tooltipArrowStyles.push(css({
                    ':after': {
                        content: '" "',
                        borderLeft: '10px solid transparent',
                        borderRight: '10px solid transparent',
                        borderTop: `10px solid ${tokens.color.background.surface}`,
                        bottom: '-10px',
                        left: '50%',
                        transform: 'translateX(-50%)'
                    }
                }));
            } else if (placement === 'right') {
                tooltipArrowStyles.push(css({
                    translate: '12px 0'
                }));
                tooltipArrowStyles.push(css({
                    ':after': {
                        content: '" "',
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderRight: `10px solid ${tokens.color.background.surface}`,
                        left: '-10px',
                        top: '50%',
                        transform: 'translateY(-50%)'
                    }
                }));
            } else if (placement === 'bottom') {
                tooltipArrowStyles.push(css({
                    translate: '0 14px'
                }));
                tooltipArrowStyles.push(css({
                    ':after': {
                        content: '" "',
                        borderLeft: '10px solid transparent',
                        borderRight: '10px solid transparent',
                        borderBottom: `10px solid ${tokens.color.background.surface}`,
                        top: '-10px',
                        left: '50%',
                        transform: 'translateX(-50%)'
                    }
                }));
            } else if (placement === 'left') {
                tooltipArrowStyles.push(css({
                    translate: '-12px'
                }));
                tooltipArrowStyles.push(css({
                    ':after': {
                        content: '" "',
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderLeft: `10px solid ${tokens.color.background.surface}`,
                        right: '-10px',
                        top: '50%',
                        transform: 'translateY(-50%)'
                    }
                }));
            }
            return tooltipArrowStyles;
        })
    ]
});

//# sourceMappingURL=tooltip.js.map